import React from 'react';

import { ToggleButton } from '@mui/material';

import ToolbarToggleInput from '../base/ToolbarToggleInput';

type Props = {
  label: string;
  name: string;
};
export default function TextAlign({ label, name }: Props) {
  return (
    <ToolbarToggleInput label={label} name={name}>
      <ToggleButton value="uppercase">Uppercase</ToggleButton>
      <ToggleButton value="none">None</ToggleButton>
    </ToolbarToggleInput>
  );
}
